/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
import { postAnalyticsAction } from '@eventbrite/site-analytics';

export const ONBOARDING_RESPONSES_ACTION = 'OnboardingResponsesAction';
export const ONBOARDING_ACTION = 'OnboardingAction';

export interface SaveAnalyticsAnswerRequest {
    userId: string;
    questionId: number;
    answerId: number;
}
interface SaveAnalyticsPhoneNumberRequest {
    userId: string;
    phoneNumber: string;
    companyName: string;
}
export const saveResponseAnalytics = async ({
    userId,
    questionId,
    answerId,
}: SaveAnalyticsAnswerRequest) => {
    const dimensions = {
        user_id: userId,
        question_id: questionId,
        answer_id: answerId,
    };

    return postAnalyticsAction(ONBOARDING_RESPONSES_ACTION, dimensions);
};
export const saveCompanyInformationAnalytics = async ({
    userId,
    phoneNumber,
    companyName,
}: SaveAnalyticsPhoneNumberRequest) => {
    const dimensions = {
        user_id: userId,
        phone: phoneNumber,
        company: companyName,
    };

    return postAnalyticsAction(ONBOARDING_ACTION, dimensions);
};
